"use client";
import { RouteError } from "@/components/route-error";
export default function PortugueseErrorPage({ reset }: { reset: () => void }) {
  return <RouteError locale="pt" reset={reset} />;
}
